<template>
    <div></div>
</template>
<script>
    export default {
        data() {
            return {
                map: null,
                marker: null
            }
        },
        props: {
            lat: {
                type: Number,
                required: true
            },
            lng: {
                type: Number,
                required: true
            }
        },
        methods: {
            mapReady(map) {
                this.map = map
                this.marker = new window.google.maps.Marker({
                    position: {
                        lat: this.lat, lng: this.lng
                    },
                    map: this.map,
                    animation: window.google.maps.Animation.DROP
                })

            }
        }
    }
</script>